import { Button, Tabs, Select } from "antd";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { LookupNames } from "../../../../../../core/constants/lookup";
import { addTrackedItemTypeRoute } from "../../../../../../core/constants/routesPath";
import { SessionVariables } from "../../../../../../core/constants/SessionVariables";
import { SessionStorage } from "../../../../../../core/helpers/localStorage/sessionStorage";
import { getLookupByListing } from "../../../../../../core/helpers/lookupHanlder";
import useDidMount from "../../../../../../core/hooks/useDidMount";
import UsePrintPage from "../../../../../../core/hooks/usePrintPage";
import localize from "../../../../../../core/utils/translation-files";
import Header from "../../../../../../layout/components/common/header";
import PrintButton from "../../../../../../layout/components/common/PrintButton";
import RenderSvg from "../../../../../../layout/components/icons/RenderSvg";
import ListingSearch from "../../../../../../layout/components/listingSearch";
import { getLookups } from "../../../../../../redux/lookup/actions";
import SystemCreatedTypesListingContainer from "./system-created-tracked-item-type";
import UserCreatedTypesListingContainer from "./user-created-tracked-item-type";
import isEmpty from "../../../../../../core/helpers/isEmpty";
import { TrackedItemsVariables } from "../../../../../../core/constants/TrackedItemsConstants";
import { clearTags, getMoreTags, getTags } from "../../../../../../redux/tags/actions";
import { clearSearchInputSuccess } from "../../../../../../redux/listingSearchInput/actions";
const ManageTrackedItemTypesContainer = ({ benchmarkListOptions, getLookups, }) => {
    var _a;
    const { TabPane } = Tabs;
    const dispatch = useDispatch();
    const [selectedTab, setSelectedTab] = useState(SessionStorage.getKey(SessionVariables.DEFAULTS_ACTIVE_TAB) || "1");
    // const searchValue = useSelector(
    //   (state: RootStateOrAny) => state?.searchInput || ""
    // );
    const history = useHistory();
    const queryParams = (_a = history.location.state) === null || _a === void 0 ? void 0 : _a.queryParams;
    const searchValue = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.searchInput) || "";
    const { items: availableTags = [], page: tagPage = 0, last: tagLast = false, } = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.tags) !== null && _a !== void 0 ? _a : {}; });
    const [selectedTag, setSelectedTag] = useState(SessionStorage.getKey("defaultsTag", sessionStorage) || undefined);
    const [lastActionType, setLastActionType] = useState(null);
    const currentSearch = useRef(searchValue);
    const [tagDropdownOpen, setTagDropdownOpen] = useState(false);
    const [tagSearchRaw, setTagSearchRaw] = useState("");
    const [tagSearch, setTagSearch] = useState("");
    const [tagSelectLoading, setTagSelectLoading] = useState(false);
    const TAG_PAGE_SIZE = 10;
    const tagsInitialLoadRef = useRef(false);
    // const hist = useHistory();
    // const { browserHistory } = useContext(browserHistoryMemoryContext);
    // const history = useMemo(() => {
    //   return browserHistory ?? hist;
    // }, [browserHistory, hist]);
    const handleChange = (activeKey) => {
        var _a;
        if (activeKey !== selectedTab) {
            if (((_a = currentSearch.current) === null || _a === void 0 ? void 0 : _a.length) < TrackedItemsVariables.MINIMUM_SEARCH_LENGTH) {
                history.push(history.location.pathname, Object.assign(Object.assign({}, queryParams), { searchInput: "", subject: "" }));
            }
            else {
                history.push(history.location.pathname, {
                    queryParams: Object.assign(Object.assign({}, queryParams), { 
                        //   subject: queryParams?.subject,
                        // searchInput: queryParams?.searchInput,
                        // page: 1,
                        // limit: queryParams?.limit,
                        sort: "name", order: "ascend" // add or update key
                     })
                });
            }
            setSelectedTab(activeKey);
            SessionStorage.setKey(SessionVariables.DEFAULTS_ACTIVE_TAB, activeKey);
            setSelectedTab(activeKey);
        }
    };
    useDidMount(() => {
        getLookupByListing({
            LookupNames: [LookupNames.LKReportTypeBenchmark],
            getLookups,
        });
    });
    useEffect(() => {
        setTimeout(() => {
            const storageActiveTab = SessionStorage.getKey(SessionVariables.DEFAULTS_ACTIVE_TAB);
            if (storageActiveTab !== selectedTab && !isEmpty(storageActiveTab)) {
                setSelectedTab(storageActiveTab);
            }
        }, 10);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        const id = setTimeout(() => setTagSearch(tagSearchRaw.trim()), 300);
        return () => clearTimeout(id);
    }, [tagSearchRaw]);
    const fetchTags = useCallback((search = "") => {
        setTagSelectLoading(true);
        dispatch(clearTags());
        dispatch(getTags({ page: 0, size: TAG_PAGE_SIZE, search })).finally(() => setTagSelectLoading(false));
    }, [dispatch]);
    useEffect(() => {
        if (!tagsInitialLoadRef.current) {
            tagsInitialLoadRef.current = true;
            fetchTags("");
            return;
        }
        if (tagSearch !== undefined && tagSearch !== null)
            fetchTags(tagSearch);
        // eslint-disable-next-line react-hooks-exhaustive-deps
    }, [tagSearch, fetchTags]);
    useEffect(() => {
        const trimmedSearch = searchValue ? searchValue.trim() : "";
        if (trimmedSearch.length >= TrackedItemsVariables.MINIMUM_SEARCH_LENGTH) {
            setLastActionType("search");
        }
        else if (!trimmedSearch && !selectedTag) {
            setLastActionType(null);
        }
    }, [searchValue, selectedTag]);
    useEffect(() => {
        const trimmedSearch = searchValue ? searchValue.trim() : "";
        if (trimmedSearch.length >= 1 &&
            selectedTag) {
            setSelectedTag(undefined);
            SessionStorage.setKey("defaultsTag", null, sessionStorage);
        }
    }, [searchValue, selectedTag]);
    const handleTagSelectChange = (value) => {
        if (value) {
            setSelectedTag(value);
            SessionStorage.setKey("defaultsTag", value, sessionStorage);
            history.push(history.location.pathname, Object.assign(Object.assign({}, queryParams), { searchInput: "", subject: "" }));
            setLastActionType("tag");
            dispatch(clearSearchInputSuccess());
        }
        else {
            setSelectedTag(undefined);
            SessionStorage.setKey("defaultsTag", null, sessionStorage);
            history.push(history.location.pathname, Object.assign(Object.assign({}, queryParams), { searchInput: "", subject: "" }));
            const trimmedSearch = searchValue ? searchValue.trim() : "";
            if (!trimmedSearch) {
                setLastActionType(null);
            }
        }
    };
    const resetSearch = () => {
        var _a, _b;
        if (((_a = currentSearch.current) === null || _a === void 0 ? void 0 : _a.length) !== 0 && ((_b = currentSearch.current) === null || _b === void 0 ? void 0 : _b.length) < TrackedItemsVariables.MINIMUM_SEARCH_LENGTH) {
            history.push(history.location.pathname, Object.assign(Object.assign({}, queryParams), { searchInput: "", subject: "" }));
        }
    };
    const handleTagPopupScroll = (event) => {
        const target = event === null || event === void 0 ? void 0 : event.target;
        if (!target)
            return;
        const nearBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 24;
        if (nearBottom && !tagLast && !tagSelectLoading) {
            setTagSelectLoading(true);
            dispatch(getMoreTags({
                page: (tagPage !== null && tagPage !== void 0 ? tagPage : 0) + 1,
                size: TAG_PAGE_SIZE,
                search: tagSearch || "",
            })).finally(() => setTagSelectLoading(false));
        }
    };
    const isHidden = selectedTab === TrackedItemsVariables.HIDDEN_TRACKED_ITEM;
    const buttonText = () => {
        if (selectedTab === TrackedItemsVariables.USER_TRACKED_ITEM) {
            return localize(["add", "TrackedItem.default"]);
        }
        else if (selectedTab === TrackedItemsVariables.SYSTEM_TRACKED_ITEM) {
            return localize([
                "add",
                "TrackedItem.indexCategory",
                "TrackedItem.default",
            ]);
        }
        else {
            return localize([
                "add",
                // "TrackedItem.indexCategory",
                "TrackedItem.hiddenTrackedItem",
                "TrackedItem.default",
            ]);
        }
    };
    const { handlePrint, nodeRef } = UsePrintPage();
    return (React.createElement("div", { ref: nodeRef },
        React.createElement(Header, { rightComponent: React.createElement("div", { className: "row", style: { alignItems: "center" } },
                React.createElement(ListingSearch, { placeholder: "Search (min 3 chars)", clientSide: false, minTextLength: 3, searchCallback: (val) => currentSearch.current = val, debounceTime: 1500 }),
                React.createElement(Select, { allowClear: true, showSearch: true, placeholder: "Filter by tag", value: selectedTag, style: { width: 200, marginRight: "10px", background: "#fff" }, dropdownStyle: {
                        maxHeight: 280,
                        overflow: "auto",
                        background: "#fff",
                    }, listHeight: 240, virtual: false, filterOption: false, loading: tagSelectLoading, onDropdownVisibleChange: (open) => {
                        setTagDropdownOpen(open);
                        if (!open) {
                            setTagSearchRaw("");
                            setTagSearch("");
                        }
                    }, onPopupScroll: handleTagPopupScroll, onSearch: (value) => setTagSearchRaw(value), onChange: (value) => handleTagSelectChange(value), options: availableTags === null || availableTags === void 0 ? void 0 : availableTags.map((tag) => ({
                        value: tag === null || tag === void 0 ? void 0 : tag.name,
                        label: tag === null || tag === void 0 ? void 0 : tag.name,
                    })), dropdownMatchSelectWidth: true }),
                React.createElement(PrintButton, { printOnClick: handlePrint }),
                React.createElement(Link, { to: {
                        pathname: addTrackedItemTypeRoute,
                    } },
                    React.createElement(Button, { htmlType: "button", type: "primary" },
                        React.createElement(RenderSvg, { icon: "AddDefault" }),
                        buttonText()))) }),
        React.createElement(Tabs, { className: 'defaults-tabs-container', defaultActiveKey: selectedTab, activeKey: selectedTab, onChange: handleChange },
            React.createElement(TabPane, { tab: "Tracked Items Default", key: TrackedItemsVariables.USER_TRACKED_ITEM, id: "tracked-item-definitions" }, selectedTab === TrackedItemsVariables.USER_TRACKED_ITEM && (React.createElement(UserCreatedTypesListingContainer, { benchmarkListOptions: benchmarkListOptions, isHidden: isHidden, selectedTag: selectedTag, lastActionType: lastActionType, resetSearch: resetSearch }))),
            React.createElement(TabPane, { tab: "Index/Category Defaults", key: TrackedItemsVariables.SYSTEM_TRACKED_ITEM, id: "tracked-item-type-defaults" },
                " ",
                selectedTab === TrackedItemsVariables.SYSTEM_TRACKED_ITEM && (React.createElement(SystemCreatedTypesListingContainer, { benchmarkListOptions: benchmarkListOptions, selectedTag: selectedTag, lastActionType: lastActionType, resetSearch: resetSearch }))),
            React.createElement(TabPane, { tab: "Tracked Item Components Default", key: TrackedItemsVariables.HIDDEN_TRACKED_ITEM, id: "hidden-tracked-item" },
                " ",
                selectedTab === TrackedItemsVariables.HIDDEN_TRACKED_ITEM && (React.createElement(UserCreatedTypesListingContainer, { benchmarkListOptions: benchmarkListOptions, isHidden: isHidden, selectedTag: selectedTag, lastActionType: lastActionType, resetSearch: resetSearch }))))));
};
function mapStateTopProps(state) {
    var _a, _b;
    return {
        benchmarkListOptions: (_b = (_a = state.lookups[LookupNames.LKReportTypeBenchmark]) === null || _a === void 0 ? void 0 : _a.map(({ text }) => text)) !== null && _b !== void 0 ? _b : [],
    };
}
const mapDispatchToProps = {
    getLookups,
};
export default connect(mapStateTopProps, mapDispatchToProps)(ManageTrackedItemTypesContainer);
